import { render, staticRenderFns } from "./billing-grid-actions-invoices.vue?vue&type=template&id=1472e9a6&scoped=true&"
import script from "./billing-grid-actions-invoices.ts?vue&type=script&lang=ts&"
export * from "./billing-grid-actions-invoices.ts?vue&type=script&lang=ts&"
import style0 from "./billing-grid-actions-invoices.scss?vue&type=style&index=0&id=1472e9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472e9a6",
  null
  
)

export default component.exports